import { render, staticRenderFns } from "./DetailModalV2.vue?vue&type=template&id=6fc2d694&scoped=true"
import script from "./DetailModalV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailModalV2.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DetailModalV2.vue?vue&type=style&index=0&id=6fc2d694&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc2d694",
  null
  
)

export default component.exports